export default __webpack_public_path__ + "static/media/iq.bbc92f03.svg";